import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgPlayStore = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 25 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        d="M3.995 2.774q-.091.272-.092.627v17.197q.001.356.092.628L13.22 12zM4.722 21.964c.326.086.726.02 1.157-.225l10.891-6.19-2.817-2.816zM17.706 15.02l3.336-1.897c1.087-.618 1.087-1.628 0-2.245L17.704 8.98l-3.018 3.018zM16.77 8.45 5.878 2.26c-.431-.245-.831-.311-1.157-.225l9.23 9.23z"
      />
    </svg>
  );
};
export default SvgPlayStore;
